import { useRef } from "react";

/**
 * Socket hook'ları için token (#142).
 *
 * Socket'ler eskiden `[token]` bağımlılığıyla kuruluyordu: token her yenilendiğinde
 * (odak, süre sonu, 401) bağlantı kapanıp yeniden açılıyor, canlı akış kopuyordu.
 * Artık bağlantı yalnız oturum açılıp kapanınca (`hasToken`) kurulur; güncel token
 * `tokenRef`'te durur ve yeniden bağlanırken kullanılır (`attachTokenOnReconnect`).
 */
export default function useLatestToken(token) {
  const tokenRef = useRef(token);
  tokenRef.current = token;
  return { hasToken: !!token, tokenRef };
}

/** Socket yeniden bağlanırken handshake'e o anki token'ı koyar. */
export function attachTokenOnReconnect(socket, tokenRef) {
  if (!socket?.io?.on) return;
  socket.io.on("reconnect_attempt", () => {
    const opts = socket.io.opts || {};
    opts.query = { ...(opts.query || {}), token: tokenRef.current };
    socket.io.opts = opts;
  });
}
